import { editorPick } from "@/mocks/gossipData";

export default function EditorPick() {
  return (
    <section id="editor" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="relative order-2 lg:order-1">
            <div className="relative aspect-[16/10] w-full overflow-hidden rounded-3xl">
              <img src={editorPick.cover} alt={editorPick.title} className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent"></div>
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-4 py-1.5 text-xs font-semibold text-background-50">
                <i className="ri-vip-crown-line"></i>
                {editorPick.category}
              </span>
            </div>
            <div className="absolute -bottom-5 left-4 rounded-2xl bg-background-50 px-5 py-3 shadow-soft md:left-6">
              <div className="text-[11px] text-foreground-500">阅读约需</div>
              <div className="font-heading text-xl font-bold text-primary-600">
                {editorPick.readMinutes} 分钟
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-quill-pen-fill"></i>
              主编精选单篇
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
              {editorPick.title}
            </h2>
            <p className="mt-2 text-sm font-medium text-accent-700">{editorPick.subtitle}</p>

            <div className="mt-4 space-y-3">
              {editorPick.body.slice(0, 3).map((p, i) => (
                <p key={i} className="text-sm leading-relaxed text-foreground-700">
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-5 flex flex-wrap items-center gap-3 border-t border-background-200 pt-4 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-edit-line text-accent-600"></i>
                撰文：{editorPick.author}
              </span>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-calendar-line"></i>
                {editorPick.date}
              </span>
            </div>

            <div className="mt-5 flex flex-wrap gap-2">
              <a
                href="#subscribe"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors"
              >
                收藏本合集
                <i className="ri-bookmark-line"></i>
              </a>
              <button
                type="button"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-800 hover:bg-background-200/60 transition-colors"
              >
                分享给瓜友
                <i className="ri-share-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}